import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';

import store from './store';
import App from './components/App';
import FontStyles from './styles/fontStyles';
import ResetStyles from './styles/resetStyles';
import NormalizeStyles from './styles/normalizeStyles';
import GlobalStyles from './styles/globalStyles';

ReactDOM.render(
    <BrowserRouter>
        <Provider store={store}>
            <FontStyles />
            <ResetStyles />
            <NormalizeStyles />
            <GlobalStyles />
            <App />
        </Provider>
    </BrowserRouter>,
    document.getElementById('root')
);

registerServiceWorker();
